import { render } from "./ModalExcluirPrograma.vue?vue&type=template&id=37ed97fc"
import script from "./ModalExcluirPrograma.vue?vue&type=script&lang=js"
export * from "./ModalExcluirPrograma.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__